module.exports = __webpack_public_path__ + "media/images/geo-74a742b7195e1706a90473ea2b753a24.svg";